import React from 'react';
import '../../styles/Navigation.css';

export default function Navigation({ 
  type = 'none', // 'single-button', 'musical-player', 'none'
  buttonText = 'Далі',
  buttonBgColor,
  onNext, 
  onPrev, 
  canGoNext, 
  canGoPrev,
  onHome,
  onRestart
}) {

  // Якщо навігація вимкнена
  if (type === 'none') {
    return null;
  }

  return (
    <div className={`navigation-container ${type}`}>
      {/* Одна кнопка з текстом */}
      {type === 'single-button' && (
        <button 
          className="nav-single"
          onClick={onNext}
          disabled={!canGoNext}
          style={{background: `${buttonBgColor}`}}
        >
          {buttonText}
        </button>
      )}

      {type === 'restart-button' && (
        <button 
          className="nav-single"
          onClick={onRestart}
          style={{background: `${buttonBgColor}`}}
        >
          {buttonText}
        </button>
      )}

       {/* Музикальний плеєр */}
      {type === 'musical-player' && (
        <button 
          className="nav-single"
          onClick={onNext}
          disabled={!canGoNext}
          style={{background: `${buttonBgColor}`}}
        >
          Пропустити
        </button>
      )}
    </div>
  );
}
